import React, { useState, useContext } from "react";
import {
  Button,
  Divider,
  Chip,
  TextField,
  FormHelperText,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../admin/context/FirebaseContext";

import "../styles/login.style.scss";

import { ReactComponent as Logo } from "./../logo.svg";
const MESSAGE_ERROR = {
  "auth/network-request-failed": "Impossible de se connecter sur internet",
  "auth/invalid-login-credentials": "Email ou Mot de Passe incorrecte(s)",
  "auth/too-many-requests":
    "Beaucoup de tentives de connexion essayer de modifier le mot De Passe",
};
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [onSubmit, setOnSubmit] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [Error, setError] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const { doSignInWithEmailAndPassword } = useContext(FirebaseContext);

  function clearInputError() {
    setTimeout(() => {
      setPasswordError(false);
      setEmailError(false);
      setError("");
    }, 3000);
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    setEmailError(false);
    setPasswordError(false);

    if (email === "") {
      setEmailError(true);
    }
    if (password === "") {
      setPasswordError(true);
      clearInputError();
    }

    if (email && password) {
      setPasswordError(false);
      setEmailError(false);
      setOnSubmit(true);
      setError("");
      doSignInWithEmailAndPassword(email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          setDone(true);
          setTimeout(() => {
            navigate("/admin", {
              replace: true,
            });
          }, 1000);
          // Signed in

          // ...
        })
        .catch((error) => {
          setOnSubmit(false);
          setPasswordError(true);
          setEmailError(true);
          const errorCode = error.code;
          const errorMessage = error.message;
          setError(MESSAGE_ERROR[errorCode] ?? errorCode);
          clearInputError();
        });
    }
  };
  return (
    <div className="App top-ctn">
      <div className="ctn-container ctn-content">
        <div className="login__container">
          <form className="login__from" onSubmit={handleSubmit}>
            <Logo className="login__logo" />
            <Divider>
              <Chip label="Connexion" />
            </Divider>
            <TextField
              error={emailError}
              //fullWidth
              id="outlined-required"
              label="Email"
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              color={done ? "success" : "primary"}
              focused={done}
              sx={{
                width: "100%",
                margin: "10px 0",
              }}
            />
            <TextField
              //fullWidth
              id="outlined-password-input"
              label="Password"
              type="password"
              error={passwordError}
              onChange={(e) => setPassword(e.target.value)}
              color={done ? "success" : "primary"}
              focused={done}
              sx={{
                width: "100%",
              }}
              //onFocus={setPasswordError(false)}
            />
            <FormHelperText id="my-helper-text" error>
              {Error}
            </FormHelperText>
            <Button
              type="submit"
              size="large"
              variant="contained"
              color={done ? "success" : "primary"}
              disabled={onSubmit && !done}
              sx={{
                width: "100%",
                margin: "10px 0",
              }}
            >
              Se Connecter
            </Button>
            {/*<span>
              
              <Link href="#" underline="hover">
                {"Modifier"}Mot de passe oublier?{" "}
              </Link>
  </span>*/}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
